import { zusToast } from '@zep/toast';
import { VoucherToastView } from './VoucherToastView';
type VoucherToastCopy = {
  actionLabel: string;
  closeButtonLabel: string;
  description?: string;
  title: string;
};

/** 결과를 알리기만 하는 토스트. zusToast.success 기본값과 같다. */
const NOTICE_DURATION = 2_000;

/**
 * 안내가 목적인 토스트. 액션 버튼을 읽고 누를 시간이 필요해 더 길게 잡는다.
 * 2초로 두면 갈 곳을 알려주려고 띄운 토스트를 눌러 보기도 전에 사라진다.
 */
const GUIDANCE_DURATION = 4_000;

/**
 * 이용권 결과 토스트 공통 표시기.
 *
 * `zusToast.success` 가 아니라 `zusToast.custom` 을 쓰는 이유는
 * {@link VoucherToastView} 주석 참고 — 시안이 ZUS Toast 마스터와 어긋난다.
 *
 * 위치를 명시하는 이유: ZusToaster 기본이 bottom-center 라 그대로 두면 시안과 어긋난다.
 *
 * 액션을 누르면 토스트도 닫는다 — 어차피 다른 화면으로 떠나므로 남겨 둘 이유가 없다.
 */
const showVoucherToast = (onAction: () => void, copy: VoucherToastCopy, duration: number) => zusToast.custom(({
  dismiss
}) => <VoucherToastView actionLabel={copy.actionLabel} closeButtonLabel={copy.closeButtonLabel} description={copy.description} title={copy.title} onAction={() => {
  onAction();
  dismiss();
}} onClose={dismiss} />, {
  duration,
  position: 'top-center',
  dismissible: true
});

/**
 * 이용권 적용 완료 토스트 (Figma 28913:51588 · 51593).
 *
 * 활성화 직후 플랜이 바뀐 사실만 알리고, 상세 확인은 플랜 관리로 넘긴다.
 * 시안이 모달이 아니라 토스트인 이유이기도 하다 — 하던 일을 끊지 않는다.
 *
 * @param onOpenPlanManagement 「플랜 관리」 액션. 라우터를 토스트가 직접 들지 않도록 주입받는다.
 */
export const showVoucherAppliedToast = (onOpenPlanManagement: () => void, copy: Required<VoucherToastCopy>) => showVoucherToast(onOpenPlanManagement, copy, NOTICE_DURATION);

/**
 * 이용권 보관 완료 토스트 (Figma 28913:51596).
 *
 * 보상 모달에서 이용권을 쓰지 않고 나갈 때 띄운다 — 「다음에」·「닫기」.
 * 창만 조용히 닫히면 방금 받은 이용권이 어디로 갔는지 알 수 없다.
 * 설명 없이 제목 한 줄이고(시안), 갈 곳은 보관함 하나뿐이다.
 *
 * 적용 토스트보다 오래 띄운다 — 이쪽은 통보가 아니라 보관함으로 가라는 안내다.
 *
 * @param onOpenVoucherStorage 「이용권 보관함」 액션.
 */
export const showVoucherStoredToast = (onOpenVoucherStorage: () => void, copy: Omit<VoucherToastCopy, 'description'>) => showVoucherToast(onOpenVoucherStorage, copy, GUIDANCE_DURATION);